/**
 * Story of Us keepsake card product handle (ALBAU-909). The card is its own cart line, linked to its piece by
 * `_giftwrap_key`, and is known by this handle on /cart.js items.
 *
 * Duplicated in `theme/src/gift-wrap/src/packaging/cart/lineRole.js` (`STORY_OF_US_CARD_HANDLE`): shared code
 * does not import theme code, so keep the two in step.
 */
export const STORY_OF_US_CARD_HANDLE = "story-of-us-keepsake-card"
